var _circle, _circle2, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_105)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0521,
    cy: 48.0521,
    r: 21.0521,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_105)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.9476,
    cy: 52.9486,
    r: 21.0521,
    fill: "url(#paint1_linear_1062_105)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.9476,
    cy: 52.9486,
    r: 21.0521,
    stroke: "url(#paint2_linear_1062_105)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3668 41.7414C52.1122 41.8518 52.0716 42.0225 52.0417 43.105C52.008 44.3292 52.0054 44.3338 51.1545 44.6696C48.8338 45.5855 47.6895 47.193 47.6923 49.5334C47.6934 50.3893 47.7861 50.8424 48.0916 51.4858C48.7233 52.8162 49.8544 53.669 52.4603 54.7795C53.0471 55.0296 53.6612 55.304 53.8249 55.3892C54.7567 55.8745 55.2456 56.5161 55.2469 57.2551C55.2491 58.6468 53.7784 59.3721 51.686 59.0111C50.8456 58.8661 49.8626 58.5559 49.2828 58.2528C49.0708 58.1419 48.8043 58.0237 48.6906 57.99C48.3391 57.886 48.1988 58.1205 47.8562 59.3845C47.5049 60.6802 47.4822 60.9748 47.7164 61.1963C48.1275 61.5849 49.1423 61.9664 50.5552 62.2636C51.1564 62.39 51.6091 62.5246 51.6804 62.598C51.7748 62.6953 51.8078 62.9339 51.8392 63.7482C51.861 64.3133 51.9036 64.83 51.9339 64.8965C52.0391 65.1273 52.3358 65.1875 53.367 65.1875C54.349 65.1875 54.389 65.1814 54.5612 65.0036C54.7464 64.8126 54.7501 64.786 54.7828 63.3899C54.8031 62.5242 54.8105 62.4854 54.9879 62.3158C55.0846 62.2233 55.3541 62.0865 55.5867 62.0117C57.8597 61.2817 59.3125 59.3359 59.3125 57.0217C59.3125 55.736 58.9276 54.6488 58.1104 53.6265C57.4417 52.79 56.4439 52.1672 54.3765 51.2957C52.8373 50.6468 52.1105 50.1563 51.8427 49.5854C51.5679 48.9998 51.6772 48.4922 52.1782 48.0257C52.6187 47.6155 52.887 47.5478 54.0498 47.5534C55.2144 47.5589 55.6942 47.6569 56.8001 48.1147C57.196 48.2786 57.5771 48.394 57.647 48.3711C57.8212 48.3141 57.9461 48.0165 58.291 46.837C58.6268 45.6884 58.6445 45.5062 58.442 45.282C58.1658 44.9761 56.9187 44.5255 55.8693 44.3525C55.4516 44.2836 54.989 44.129 54.9492 44.045C54.9448 44.0358 54.9185 43.5807 54.8907 43.0336C54.8219 41.6821 54.8523 41.7119 53.5217 41.6895C52.9738 41.6802 52.4541 41.7036 52.3668 41.7414Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_105",
    x: 29.7455,
    y: 29.7465,
    width: 46.4045,
    height: 46.4035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_105",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_105",
    x1: 36.4011,
    y1: 35.7811,
    x2: 81.847,
    y2: 59.3124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_105",
    x1: 56.4563,
    y1: 38.9138,
    x2: 72.2453,
    y2: 75.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.fe4535afda6cd7988e3cd37c80d58c93.svg";
export { ForwardRef as ReactComponent };